<template>
  <div class="cxfx">
    <Header :title=$route.meta.title></Header>
    <div v-if="type == 0">
      <van-cell title="上课年级" is-link icon="label-o" @click="sknjPop = true" :value="form.sknj"/>
      <van-cell title="上课院系" is-link icon="label-o" @click="skyxPop = true" :value="form.skyx"/>
      <van-cell title="上课专业" is-link icon="label-o" @click="skzyPop = true" :value="form.skzy"/>
      <van-cell title="上课班级" is-link icon="label-o" @click="skzyPop = true" :value="form.skbj"/>
      <van-field
        v-model="form.xh"
        label="学号"
        placeholder="请输入"
        input-align="right"
        left-icon="label-o"
      />
      <van-field
        v-model="form.name"
        label="姓名"
        placeholder="请输入"
        input-align="right"
        left-icon="label-o"
      />
    </div>
    <div v-if="type == 1">
      <van-cell title="教师所属院系" is-link icon="label-o" @click="skyxPop = true" :value="form.jsssyx"/>
      <van-cell title="职称" is-link icon="label-o" @click="zcPop = true" :value="form.zc"/>
      <van-field
        v-model="form.js"
        label="教师"
        placeholder="请输入"
        input-align="right"
        left-icon="label-o"
      />
    </div>
    <div v-if="type == 2">
      <van-cell title="开课院系" is-link icon="label-o" @click="skyxPop = true" :value="form.kkyx"/>
      <van-cell title="课程类别" is-link icon="label-o" @click="kclbPop = true" :value="form.kclb"/>
      <van-cell title="课程属性" is-link icon="label-o" @click="kcsxPop = true" :value="form.kcsx"/>
      <van-field
        v-model="form.kc"
        label="课程"
        placeholder="请输入"
        input-align="right"
        left-icon="label-o"
      />
    </div>
    <div class="btn">
      <van-button type="primary" @click="$router.push(`/query/detail?id=${type}`)">查询</van-button>
      <van-button type="primary" color="#7469F8" @click="$router.push(`/query/echart?id=${type}`)">统计分析</van-button>
    </div>
    <!-- 上课年级 -->
    <van-popup v-model="sknjPop" position="bottom">
      <van-picker 
        :columns="sknjList"
        :item-height="35"
        show-toolbar
        @cancel="sknjPop = false"
        @confirm="sknjConfirm"
      ></van-picker>
    </van-popup>
    <!-- 上课院系 -->
    <van-popup v-model="skyxPop" position="bottom">
      <van-picker 
        :columns="skyxList"
        :item-height="35"
        show-toolbar
        @cancel="skyxPop = false"
        @confirm="skyxConfirm"
      ></van-picker>
    </van-popup>
    <!-- 上课专业 -->
    <van-popup v-model="skzyPop" position="bottom">
      <van-picker 
        :columns="skzyList"
        :item-height="35"
        show-toolbar
        @cancel="skzyPop = false"
        @confirm="skzyConfirm"
      ></van-picker>
    </van-popup>
    <!-- 职称 -->
    <van-popup v-model="zcPop" position="bottom">
      <van-picker 
        :columns="zcList"
        :item-height="35"
        show-toolbar
        @cancel="zcPop = false"
        @confirm="zcConfirm"
      ></van-picker>
    </van-popup>
    <!-- 课程类别 -->
    <van-popup v-model="kclbPop" position="bottom">
      <van-picker 
        :columns="kclbList"
        :item-height="35"
        show-toolbar
        @cancel="kclbPop = false"
        @confirm="kclbConfirm"
      ></van-picker>
    </van-popup>
    <!-- 课程属性  -->
    <van-popup v-model="kcsxPop" position="bottom">
      <van-picker 
        :columns="kcsxList"
        :item-height="35"
        show-toolbar
        @cancel="kcsxPop = false"
        @confirm="kcsxConfirm"
      ></van-picker>
    </van-popup>
  </div>
</template>
<script>
export default {
  data(){
    return{
      form:{},
      sknjPop:false,
      skyxPop:false,
      skzyPop:false,
      zcPop:false,
      kclbPop:false,
      kcss:false,
      kcsxPop:false,
      type:this.$route.query.id,
      sknjList:['2015','2016','2017','2018','2019','2020'],
      skyxList:['土木工程学院','计算机学院','机械工程学院','外国语学院'],
      skzyList:['建筑设计','电子信息工程','计算机科学与技术'],
      zcList:['高级教师','教授','副教授','高级讲师'],
      kclbList:['理论课','实践课'],
      kcsxList:['必修','选修']
    }
  },
  methods:{
    sknjConfirm(e){
      this.form.sknj = e
      this.sknjPop = false
    },
    skyxConfirm(e){
      this.form.skyx = e
      this.skyxPop = false
    },
    skzyConfirm(e){
      this.form.skzy = e
      this.skzyPop = false
    },
    zcConfirm(e){
      this.form.zc = e
      this.zcPop = false
    },
    kclbConfirm(e){
      this.form.kclb = e
      this.kclbPop = false
    },
    kcsxConfirm(e){
      this.form.kcsx = e
      this.kcsxPop = false
    }
  }
}
</script>
<style scoped lang="less">
.cxfx{
  .btn{
      position: fixed;
      margin: 1.25rem;
      bottom: 0;
      width: calc(~"100% - 40px");
      display: flex;
      justify-content: space-between;
      button{
        width: calc(~"50% - 10px");
        &:first-child{
          background-color: #ECEDFD;
          color: #7469F8;
          border-color: #ECEDFD;
        }
      }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/pages/QueryAnalysis/query.vue